// extracted by mini-css-extract-plugin
module.exports = {"inputs":"Auth_inputs__1lpM0"};